var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-modal',{attrs:{"title":"保单号","visible":_vm.visible},on:{"ok":_vm.handleOk,"cancel":_vm.handleCancel}},[_c('a-input',{attrs:{"placeholder":"Basic usage"},model:{value:(_vm.insuranceNo),callback:function ($$v) {_vm.insuranceNo=$$v},expression:"insuranceNo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }